export const ListECPFModel = {
  LIMIT: 20
}
